<template>
  <div class="main-background">
    <div class="noresult-screen-full">
      <div class="input-group">
        <search-icon class="search-input-icon" />
        <input
          type="text"
          placeholder="Notcoin"
          v-model="searchLocalText"
          class="form-control search-text"
          id="search-input"
        />
      </div>
      <div v-if="!searchLocalText" class="search-filter">
        <div class="search-filter-btn">
          <button
            class="filter-button"
            @click="$emit('setIsChangePage', 'filter')"
          >
            <sliders-icon class="filter-button-icon" />
          </button>
        </div>
      </div>
    </div>
      <div class="main-page-categories-header">
        <p class="main-page-category-name">Список проектів</p>
        <!-- <button
          class="main-page-all-category-button"
          @click="onFilterByCategories('all')"
        >
          Всі
          <chevron-right-icon/>
        </button> -->
      </div>
    <!-- category-slider -->
    <div class="filter-category-list">
       <div
        :class="`filter-category-item ${!usedCategoryFilter.length && 'active'}`"
        @click="onFilterByCategories('all')"
      >
        Всі
      </div>
      <div
        :class="`filter-category-item ${usedCategoryFilter.includes(category.id) && 'active'}`"
        v-for="category of allHeaderCategories"
        :key="category.id"
        @click="onFilterByCategories(category.id)"
      >
        {{ category.name }}
      </div>
    </div>
    <!-- /category-slider -->

    <!-- category-slider -->

    <div
      v-for="category of allProducts"
      :key="category.id"
      class="main-page-category-block"
    >
          <div class="product-block" @click="setClickToProduct(category)">
            <img :src="category.img" :alt="category.name" class="product-image" />
            <div class="product-name-container">
             <button :class="`product-wish-button ${wishList.find(el => el.id === category.id) && 'product-wish-includes'}`" @click.stop="onToogleWishList(category)">
              <heart-icon class="product-wish-icon"/>
             </button>
              <p class="product-name">{{ category.name.length > 50 ? category.name.substring(0, 50) + '...' : category.name }}</p>
              <p class="product-price">{{category.price || '' }}</p>
              <p class="product-stars-raiting">
                <star-icon class="product-stars-raiting-icon"/>
                {{ category.rating }}
              </p>
              <!-- <button class="add-to-cart-button">
                <plus-icon class="add-to-cart-button-icon"/>
              </button> -->
            </div>
          </div>
    </div>

    <!-- /category-slider -->
  </div>
</template>

<script>
import { 
  SearchIcon, 
  SlidersIcon, 
 // ChevronRightIcon, 
  HeartIcon, 
  // PlusIcon, 
  StarIcon 
} from "vue-feather-icons";
import { mapMutations } from "vuex";

export default {
  name: "home-page",
  components: {
    SearchIcon,
    SlidersIcon,
    HeartIcon,
   // PlusIcon,
    StarIcon,
  //  ChevronRightIcon
  },
  props: {
  },
  data() {
    return {
      caruselBunner: [],
      searchLocalText: "",
      usedCategoryFilter: []
    };
  },
  async mounted() {
    window.scrollTo(0, 0);
  }, 
  beforeMount() {
    setTimeout(() => {
        window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    })
  },
  computed: {
    wishList() {
        return this.$store.getters.wishList
    },
    allHeaderCategories() {
      return this.$store.getters.allHeaderCategories
    },
    allProducts() {
      return this.$store.getters.allProducts
    },
    currentCustomer() {
      return this.$store.getters.currentCustomer
    }
  },
  methods: {
    ...mapMutations([
      "setIsOpenProductInfo",
      "setIsShowProducts",
      "setChangeSearchText",
      "setCheckedCategory",
      "addToWishList"
    ]),
    onToogleWishList(value) {
      let data = {
        ...value,
        customer_id: this.currentCustomer.id
      }
      this.$store.dispatch('setProductToWishes', data)
    },
    searchProducts () {
      if (!this.searchLocalText.length) {
       this.$store.dispatch('getAllProducts')
      }
      if (this.searchLocalText.length < 3) {
        return
      }
      try {
        let data = {
          q: this.searchLocalText,
          category_ids: null,
          sort: 'name'
        };
        this.$store.dispatch("searchedProducts", data);
      } catch (error) {
        console.log(error.message);
      }
    },
    onFilterByCategories(value) {
      if (value === 'all') {
        this.usedCategoryFilter = []
        this.$store.dispatch('getAllProducts')
      } else {
      if (this.usedCategoryFilter.includes(value)) {
        this.usedCategoryFilter.splice(this.usedCategoryFilter.indexOf(value), 1);
      } else {
        this.usedCategoryFilter = [...this.usedCategoryFilter, value]
      }
      let data = {
          q: this.searchLocalText,
          category_ids: this.usedCategoryFilter.join(','),
          sort: ''
        };
      this.$store.dispatch("searchedProducts", data);
      }
    },
    setOpenAllProducts(value) {
      this.setCheckedCategory(value)
      this.$emit('setIsOpenProductsPage', value.id)
    },
    setCheckCategory(value) {
      this.setCheckedCategory(value)
      if (value.id === 0) {
        this.$emit("setIsOpenProductsPage", null);
        this.setIsShowProducts("category");
      } else {
        this.$emit("setIsOpenProductsPage", value.id);
        this.setIsShowProducts("preCategory");
      }
    },
    setClickToProduct(value) {
      this.setIsOpenProductInfo(value);
      this.$emit("setIsChangePage", "productInfo");
    },
    async openProductPageInfo(id) {
      try {
        this.$store.dispatch("getOneProduct", id);
        setTimeout(() => {
          this.$emit("setIsChangePage", "productInfo");
        }, 500);
      } catch (error) {
        console.log(error.message);
      }
    },
  },
  watch: {
    searchLocalText(newValue, oldValue) {
      let val = oldValue;
      val;
      this.setChangeSearchText(newValue);
      this.searchProducts()
    },
  },
};
</script>

<style scoped>
.main-background {
  padding: 16px 16px 90px 16px;
}
.bottombar {
  position: fixed;
  bottom: 0;
  left: 50%;
  padding: 12px 0px;
  z-index: 10;
  transform: translateX(-50%);
  width: 100%;
  max-width: 960px;
  margin: auto;
  box-shadow: rgba(0, 0, 0, 0.2) 0px -1px 0px 0px;
  background-color: rgba(255, 255, 255, 0.79);
  backdrop-filter: blur(10px);
}

.tabs-inner {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 500px;
  margin: auto;
}

.tabs-inner button {
  background: transparent;
  border: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  color: #999999;
  margin: 0px 40px;
  position: relative;
}

.tabs-inner .tab.active {
  color: #2196f3;
}

.tabs-inner .tab.active svg {
  fill: #2196f3;
}

.tabs-inner button svg {
  width: 30px;
  height: auto;
  margin-bottom: 8px;
  fill: #999999;
}

.tabs-inner button .total-sum {
  position: absolute;
  font-size: 10px;
  width: 100%;
  top: 0;
  right: -32px;
  background: #2196f3;
  color: #fff;
  border-radius: 6px;
  padding: 2px 4px;
}

.to_order_menu_page {
  padding-top: 58px;
}

.to_order_title {
  margin-left: 10px;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: #000000;
}

.to_order_menu_container {
  max-width: 90%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ........................... */

.text-field {
  margin-bottom: 1rem;
}

.text-field__label {
  display: block;
  margin-bottom: 0.25rem;
  color: #757575;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

.text-field__input {
  display: block;
  width: 100%;
  height: calc(2.25rem + 2px);
  padding: 0.375rem 0.75rem;
  font-family: inherit;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #bdbdbd;
  border-radius: 12px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.text-field__input[type="search"]::-webkit-search-decoration,
.text-field__input[type="search"]::-webkit-search-cancel-button,
.text-field__input[type="search"]::-webkit-search-results-button,
.text-field__input[type="search"]::-webkit-search-results-decoration {
  -webkit-appearance: none;
}

.text-field__input::placeholder {
  color: #212529;
  opacity: 0.4;
}

.text-field__input:focus {
  color: #212529;
  background-color: #fff;
  border-color: #bdbdbd;
  outline: 0;
}

.text-field__input:disabled,
.text-field__input[readonly] {
  background-color: #f5f5f5;
  opacity: 1;
}

/* with floating label */
.text-field_floating {
  position: relative;
}

.text-field_floating .text-field__input {
  height: calc(3.5rem + 2px);
  line-height: 1.25;
  padding: 1rem 0.75rem;
}

.text-field_floating .text-field__label {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  padding: 1rem 0.75rem;
  pointer-events: none;
  border: 1px solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.15s ease-in-out, transform 0.15s ease-in-out;
}

.text-field_floating .text-field__input::-moz-placeholder {
  color: transparent;
}

.text-field_floating .text-field__input::placeholder {
  color: transparent;
}

.text-field_floating .text-field__input:focus,
.text-field_floating .text-field__input:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}

.text-field_floating .text-field__input:focus ~ .text-field__label,
.text-field_floating
  .text-field__input:not(:placeholder-shown)
  ~ .text-field__label {
  opacity: 0.65;
  transform: scale(0.85) translateY(-0.75rem) translateX(0.15rem);
}

.wrong_label {
  color: #ff2c20;
}

.wrong_format_message {
  margin-top: 8px;
  color: #ff2c20;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

.opened_input_options_container {
  width: 100%;
  position: relative;
}

.opened_input_result_text {
  position: relative;
  border-radius: 12px;
  border: 1px solid #bdbdbd;
  padding: 8px 16px;
  height: 58px;
}

.opened_input_results {
  position: absolute;
  width: 100%;
  border: 1px solid #bdbdbd;
  border-radius: 5px;
  padding: 10px;
  z-index: 100;
}

.opened_input_text {
  padding: 5px;
  color: #000;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

.opened_input_icon {
  position: absolute;
  right: 20px;
  top: 18px;
  transition: all 0.5s ease;
}

.opened_input_rotate {
  transform: rotate(180deg);
}

.opened_input_placeholder {
  position: absolute;
  top: 18px;
  left: 10px;
  height: 100%;
  pointer-events: none;
  border: 1px solid transparent;
  transform-origin: 0 0;
  color: #757575;
  font-size: 16px;
  transition: opacity 0.15s ease-in-out, transform 0.15s ease-in-out;
}

.active_opened {
  top: 6px;
  left: 10px;
  font-size: 13px;
}

.used_input_delivery_name {
  margin-top: 20px;
}

.small_inputs_container {
  display: flex;
  gap: 20px;
}

.error_number_icon {
  position: absolute;
  top: 18px;
  right: 20px;
  color: #ff2c20;
}

.success-payment-method-icon {
  position: absolute;
  top: 18px;
  right: 20px;
}

.send_order_button {
  padding: 16px 24px;
  width: 100%;
  border-radius: 12px;
  background: #1f1f1f;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
}

@media (min-width: 700px) {
  .to_order_menu_container {
    max-width: 50%;
  }
}

/* new styles */

.top-navbar_full {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 11px 16px;
}

.skip_btn a {
  color: #707070;
  text-align: right;
  font-family: "Comfortaa", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
}

.noresult-screen-full {
  display: flex;
  align-items: center;
  column-gap: 12px;
}

.input-group {
  position: relative;
  display: flex;
  align-items: stretch;
  width: 100%;
}

.form-control {
  padding: 8px 15px;
  border: 1px solid #eee;
  line-height: 22px;
  border-radius: 5px;
  font-size: 13px;
  color: #999;
}

input:focus,
input:active,
.form-control:focus,
.form-control:active {
  outline: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  border: 1px solid #eee;
  color: #777;
}

.search-text {
  background: #1D1D1D !important;
  padding: 12px;
  border: none;
  color: #fff;
  font-family: "Comfortaa";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  width: 100%;
  padding-left: 50px;
  outline: none;
}


.search-text::placeholder {
  color: #fff;
  font-family: "Comfortaa";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

.search-iconn:focus-visible,
.search-text:focus {
  outline: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.search-filter-btn a {
  border-radius: 8px;
  background: #ff4c3b;
  padding: 12px;
  display: inline-block;
}

.search-input-icon {
  position: absolute;
  top: 12px;
  left: 12px;
  color: #fff;
}

.filter-button-icon {
  width: 24px;
    height: 24px;
    transform: rotate(90deg);
    color: #fff;
    display: block;
    margin: auto;
}

.filter-button {
  width: 48px;
  height: 48px;
  background: #1E7CE9;
  border: none;
  border-radius: 10px;
  cursor: pointer;
}

.nav-pills {
  display: flex;
  list-style: none;
}

.vue-carusel-container {
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
  margin-top: 24px;
}

.vue-carusel-banner {
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
  margin-top: 11px;
}

.custom-carusel-styles {
  width: auto !important;
}

.slide-category-button {
  border-radius: 16px;
  border: 1px solid #b5b9bf;
  background: transparent;
  color: #333;
  text-align: center;
  font-family: "Inter", sans-serif;
  font-size: 10px;
  font-weight: 600;
  line-height: 18px;
  padding: 7px 10px;
}

.baner-image-style {
  width: 100%;
  cursor: pointer;
}

.filter-category-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
  margin-top: 16px;
}
.filter-category-item {
  border-radius: 16px;
  border: 2px solid #FFF;
  color: #fff;
  text-align: center;
  font-family: "Comfortaa", sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  padding: 7px 10px;
  cursor: pointer;
}

.filter-category-item.active {
  background: #fff;
  color: #121212;
}

.main-page-category-block {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.main-page-category-name {
  color: #fff;
  font-family: "Comfortaa";
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px; 
  max-width: 70%;
}

.main-page-categories-header {
  display: flex;
  justify-content: space-between;
  margin-top: 13px;
}
.main-page-all-category-button {
  background-color: transparent;
  border: none;
  color: #A0A0A0;
  text-align: right;
  font-family: 'Comfortaa';
  font-size: 16px;
  font-weight: 600;
  line-height: 24px; 
  cursor: pointer;
}

.main-page-all-category-button svg {
  vertical-align: -6px;
}

.product-block {
  position: relative;
  width: 100%;
  display: flex;
  gap: 12px;
}
.product-image {
  width: 128px;
  height: 110px;
  border-radius: 8px;
  object-fit: cover;
  object-position: center;
}
.product-name-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.product-name {
  max-width: 150px;
  max-height: 50px;
  color: #FFF;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: "Comfortaa";
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
}
.product-price {
  color: #FFF;
  font-family: 'Comfortaa', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  margin-top: auto;
}
.product-wish-button {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 28px;
  height: 28px;
  background: #1D1D1D;
  border: none;
  padding: 6px;
  border-radius: 50%;
}
.product-wish-icon {
  display: block;
  color: #A0A0A0;
  width: 15px;
  height: 15px;
}

.product-wish-includes .product-wish-icon {
  color: #1E7CE9;
  fill: #1E7CE9;
}

.add-to-cart-button {
  position: absolute;
  bottom: 0px;
  right: 0px;
  width: 28px;
  height: 28px;
  background: #FFFFFF;
  border: none;
  border-radius: 5px;
}
.add-to-cart-button-icon {
  color: #121212;
  display: block;
  margin: auto;
}

.product-stars-raiting {
  color: #A0A0A0;
  font-family: 'Comfortaa', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  margin-top: 12px;
}

.product-stars-raiting-icon {
    fill: #1E7CE9;
    color: #1E7CE9;
    width: 16px;
    height: 16px;
    vertical-align: -3px;
}
</style>